module.exports = __webpack_public_path__ + "static/media/next.2c0cd454.png";